"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var process_dto_1 = require("../model/process.dto");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var ServiceBase_1 = require("../service/ServiceBase");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var http_1 = require("@angular/common/http");
var process_with_track_info_dto_1 = require("../model/process-with-track-info.dto");
var process_structure_dto_1 = require("../model/process-structure.dto");
var state_dto_1 = require("../model/state.dto");
var action_indexed_dto_1 = require("../model/action-indexed.dto");
/**
 * ProcessService implementation
 */
var HttpProcessService = /** @class */ (function (_super) {
    __extends(HttpProcessService, _super);
    function HttpProcessService(http, applicationPropertiesService) {
        var _this = _super.call(this, 'workflow-service-url', applicationPropertiesService) || this;
        _this.http = http;
        return _this;
    }
    HttpProcessService_1 = HttpProcessService;
    /**
     * Get all processes
     * @returns {Promise<Array<ProcessDto>>}
     */
    HttpProcessService.prototype.getProcesses = function () {
        var _this = this;
        return this.loadedServiceUrl.then(function (url) {
            return _this.http.get(HttpProcessService_1.PROCESSES_PATH.replaceTemplate({
                serviceUri: url
            }), { params: { 'expand': 'simple' } }).map(function (response) { return _this.extractProcesses(response); }).toPromise();
        });
    };
    HttpProcessService.prototype.getProcessesWithTrackInfo = function () {
        var _this = this;
        return this.loadedServiceUrl.then(function (url) {
            return _this.http.get(HttpProcessService_1.PROCESSES_PATH.replaceTemplate({
                serviceUri: url
            }), { params: { 'expand': 'track' } }).map(function (response) { return _this.extractDetailedProcesses(response); }).toPromise();
        });
    };
    /**
     * Get process by id
     * @param id
     * @returns {Promise<ProcessDto>}
     */
    HttpProcessService.prototype.getProcessById = function (id) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        return this.loadedServiceUrl.then(function (url) {
            return _this.loadProcessById(url, id).toPromise();
        });
    };
    HttpProcessService.prototype.getStructure = function (id) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        return this.loadedServiceUrl.then(function (url) {
            var sendingUrl = HttpProcessService_1.PROCESS_BY_PROCESS_ID_PATH.replaceTemplate({
                serviceUri: url,
                processId: '' + id
            });
            return _this.http.get(sendingUrl, { params: { 'expand': 'structure' } }).map(function (res) { return _this.createStructureDto(res); })
                .toPromise();
        });
    };
    /**
     * Save process
     * @param process
     * @returns {Promise<number>} saved process's id
     */
    HttpProcessService.prototype.save = function (process) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(process);
        var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
        return this.loadedServiceUrl.then(function (url) {
            return _this.http.post(HttpProcessService_1.PROCESSES_PATH.replaceTemplate({
                serviceUri: url
            }), process.toJson(), { headers: headers })
                .map(function (res) { return Number(res.id); })
                .toPromise();
        });
    };
    /**
     * Update the given process
     * @param id process's id which is going to be updated
     * @param process
     * @returns {Promise<number>} updated process id
     */
    HttpProcessService.prototype.update = function (id, process) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(process);
        var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
        return this.loadedServiceUrl.then(function (url) {
            var sendingUrl = HttpProcessService_1.PROCESS_BY_PROCESS_ID_PATH.replaceTemplate({
                serviceUri: url,
                processId: '' + id
            });
            return _this.http.put(sendingUrl, process.toJson(), { headers: headers })
                .toPromise();
        });
    };
    HttpProcessService.prototype.patchUpdate = function (id, process) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(process);
        var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
        return this.loadedServiceUrl.then(function (url) {
            var sendingUrl = HttpProcessService_1.PROCESS_BY_PROCESS_ID_PATH.replaceTemplate({
                serviceUri: url,
                processId: '' + id
            });
            return _this.http.patch(sendingUrl, process.toJson(), { headers: headers })
                .map(function (res) { return Number(res.id); })
                .toPromise();
        });
    };
    HttpProcessService.prototype.delete = function (id) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        return this.loadedServiceUrl.then(function (url) {
            var sendingUrl = HttpProcessService_1.PROCESS_BY_PROCESS_ID_PATH.replaceTemplate({
                serviceUri: url,
                processId: '' + id
            });
            return _this.http.delete(sendingUrl)
                .map(function (res) { return res.deleted; })
                .toPromise();
        });
    };
    HttpProcessService.prototype.loadProcessById = function (loadProcessUrl, id) {
        var _this = this;
        var sendingUrl = HttpProcessService_1.PROCESS_BY_PROCESS_ID_PATH.replaceTemplate({
            serviceUri: loadProcessUrl,
            processId: '' + id
        });
        return this.http.get(sendingUrl).map(function (response) { return _this.extractProcess(response); });
    };
    HttpProcessService.prototype.extractProcesses = function (response) {
        var _this = this;
        return response.reduce(function (acc, item) {
            var process = _this.createProcessDto(item);
            acc.push(process);
            return acc;
        }, []);
    };
    HttpProcessService.prototype.extractProcess = function (response) {
        return this.createProcessDto(response);
    };
    HttpProcessService.prototype.createProcessDto = function (item) {
        var processId = Number(item.id);
        var name = this.convertObjectToMap(item.name);
        var initialStateId = Number(item.initialStateId);
        var categorySystemName = item.categorySystemName;
        return new process_dto_1.ProcessDto(processId, name, initialStateId, categorySystemName);
    };
    HttpProcessService.prototype.extractDetailedProcesses = function (response) {
        var _this = this;
        return response.reduce(function (acc, item) {
            var process = _this.createProcessWithTrackInfoDto(item);
            acc.push(process);
            return acc;
        }, []);
    };
    HttpProcessService.prototype.createProcessWithTrackInfoDto = function (item) {
        var processId = Number(item.id);
        var name = this.convertObjectToMap(item.name);
        var initialStateId = Number(item.initialStateId);
        var categorySystemName = item.categorySystemName;
        var modifiedBy = item.modifiedBy;
        var modifiedOn = Number(item.modifiedOn);
        return new process_with_track_info_dto_1.ProcessWithTrackInfoDto(processId, name, initialStateId, categorySystemName, modifiedBy, modifiedOn);
    };
    HttpProcessService.prototype.createStateDto = function (item) {
        var id = Number(item.id);
        var name = this.convertObjectToMap(item.name);
        var description = this.convertObjectToMap(item.description || {});
        var processId = Number(item.processId);
        var isFinal = !!item.isFinal;
        return new state_dto_1.StateDto(id, name, description, processId, isFinal);
    };
    HttpProcessService.prototype.createActionIndexedDto = function (item) {
        var id = Number(item.id);
        var name = this.convertObjectToMap(item.name);
        var description = this.convertObjectToMap(item.multilingualDescription || {});
        var initialStateId = Number(item.initialStateId);
        var targetStateId = Number(item.targetStateId);
        var initialStateIndex = Number(item.initialStateIndex);
        var targetStateIndex = Number(item.targetStateIndex);
        var formId = item.formId && Number(item.formId);
        return new action_indexed_dto_1.ActionIndexedDto(id, name, description, initialStateId, targetStateId, initialStateIndex, targetStateIndex, formId);
    };
    HttpProcessService.prototype.createStructureDto = function (res) {
        var _this = this;
        var process = this.createProcessWithTrackInfoDto(res);
        var states = res.states.map(function (state) { return _this.createStateDto(state); });
        var actions = res.actions.map(function (action) { return _this.createActionIndexedDto(action); });
        var layout = res.layout;
        var initialStateIndex = res.initialStateIndex;
        return new process_structure_dto_1.ProcessStructureDto(process.getId(), process.getNameMap(), process.getInitialStateId(), process.getCategorySystemName(), process.getModifiedBy(), process.getModifiedOn(), states, actions, layout, initialStateIndex);
    };
    HttpProcessService.PROCESSES_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/processes"], ["", "/processes"])), 'serviceUri');
    HttpProcessService.PROCESS_BY_PROCESS_ID_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/processes/", ""], ["", "/processes/", ""])), 'serviceUri', 'processId');
    HttpProcessService = HttpProcessService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpProcessService);
    return HttpProcessService;
    var HttpProcessService_1;
}(ServiceBase_1.ServiceBase));
exports.HttpProcessService = HttpProcessService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=process.service.impl.js.map